import { axInst } from "../../../Components/Login/Service";

export const todays_retail = async (body) => {
  try {
    const res = await axInst.post("retails/todays_retail", body);
    return res.data.Today_retail_count;
  } catch (error) {
    console.error(error);
  }
};

export const total_retail = async (body) => {
  try {
    const res = await axInst.post("retails/total_retail", body);
    return res.data.Total_retail_count;
  } catch (error) {
    console.error(error);
  }
};

export const invoice_details = async (body) => {
  try {
    const res = await axInst.post("retails/invoice", body);
    const result = res.data.status_based_count;
    return result;
  } catch (error) {
    console.error(error);
  }
};

export const lmtdretail = async (body) => {
  try {
    const res = await axInst.post("retails/lmtd_retail", body);
    const result = res.data;
    return result;
  } catch (error) {
    console.error(error);
  }
};

export const total_retail_lmsd = async (body) => {
  try {
    const res = await axInst.post("/retails/total_retail_lmsd", body);
    const result = res.data;
    return result;
  } catch (error) {
    console.error(error);
  }
};
